import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DesignMovedToast.less');
const cx = classnames.bind(styles);

export interface IDesignMovedToastProps
{
    srcProjectName:string,
    destProjectName:string,
    originalDesignName:string,
    newDesignName:string,
    onUndo:() => void,
    onClose:() => void
}

@observer
export class DesignMovedToast extends React.Component<IDesignMovedToastProps>
{
    public render():JSX.Element
    {
        const {srcProjectName, destProjectName, originalDesignName, newDesignName, onUndo, onClose} = this.props;

        const nameConflict = originalDesignName !== newDesignName;
        const message = nameConflict
            ? <div className={cx('message')}>
                <b>{originalDesignName}</b> already exists in <b>{destProjectName}</b> and was renamed to <b>{newDesignName}</b>
            </div>
            : <div className={cx('message')}>
                Design has been moved from <b>{srcProjectName}</b> to <b>{destProjectName}</b>
            </div>;

        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Info} className={cx('iconSuccess')} />
                    <div className={cx('title')}>
                        {originalDesignName} moved
                    </div>
                </div>
                {message}
                <div className={cx('footer')}>
                    <WSPButton
                        className={cx('undoBtn')}
                        style={ButtonStyle.SimpleSecondary}
                        caption={'Undo'}
                        onClick={onUndo}
                    />
                    <WSPButton
                        className={cx('okBtn')}
                        style={ButtonStyle.Raised}
                        caption={'Ok, got it'}
                        onClick={onClose}
                    />
                </div>
                <WSPButton
                    icon={MDIcons.common.Close}
                    style={ButtonStyle.SimpleSecondary}
                    className={cx('closeBtn')}
                    onClick={onClose}
                />
            </div>
        );
    }
}
